import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Button from "../components/ui/Button";
import Input from "../components/ui/Input";
import { track } from "../utils/analytics";

function validateOrderId(orderId) {
  const trimmed = orderId?.trim();
  if (!trimmed) return { valid: false, error: "Please enter an order number" };

  const orderNum = Number(trimmed);
  if (!Number.isInteger(orderNum))
    return { valid: false, error: "Order number must only contain digits" };

  // Range validation (1000-2000)
  if (orderNum < 1000 || orderNum > 10000) {
    return {
      valid: false,
      error: "Order number must be between 1000 and 10000",
    };
  }

  return { valid: true, error: null };
}

export default function Home() {
  const [orderId, setOrderId] = useState("");
  const [error, setError] = useState("");
  const [fakeLoading, setFakeLoading] = useState(false);

  const navigate = useNavigate();

  // Scroll to top when Home component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  // function to handle 'find my order' button
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setFakeLoading(true);

    await new Promise((resolve) => setTimeout(resolve, 750));

    const validation = validateOrderId(orderId);
    const validationErrorCode =
      validation.error === "Please enter an order number"
        ? "empty"
        : validation.error === "Order number must only contain digits"
          ? "not_digits"
          : validation.error === "Order number must be between 1000 and 10000"
            ? "invalid_range"
            : validation.error
              ? "other"
              : null;
    track("Order Lookup Submitted", {
      success: validation.valid,
      validation_error: validationErrorCode,
    });
    if (!validation.valid) {
      setError(validation.error);
      setFakeLoading(false);
      return;
    }

    navigate(`/orders/${orderId.trim()}`);
  };

  return (
    <div className="w-full max-w-lg z-10 animate-slide-up">
      <form onSubmit={handleSubmit} className="space-y-12">
        {/* form 'label' */}
        <div className="space-y-2">
          {/* step title */}
          <h2 className="font-display font-medium uppercase text-5xl md:text-7xl tracking-tighter leading-[0.9] -ms-1">
            Enter Your Order ID
          </h2>
          {/* step guidelines */}
          <p className="font-mono uppercase text-xs text-collectors-gray max-w-sm pt-4">
            Please provide the order number included in your order confirmation email (eg. 1234)
          </p>
        </div>

        {/* input section */}
        <div className="space-y-4 relative">
          <Input
            label="Order ID"
            placeholder="No. XXXX"
            value={orderId}
            onChange={(e) => setOrderId(e.target.value)}
            autoFocus
          />
          {error && (
            <p className="absolute -bottom-8 left-0 font-mono text-xs text-red-600 uppercase tracking-widest">
              {error}
            </p>
          )}

          {/* submit button */}
          <div className="pt-4">
            <Button type="submit" className="w-full" disabled={!orderId || fakeLoading}>
              {fakeLoading ? "Searching..." : "Find My Order"}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
